import tzNames from './tznames.json';


const validTimeArray = Object.keys(tzNames);

const timeSet: Set<string> = new Set(validTimeArray);

export default timeSet;
